import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { DefaultValues } from '@src/util/default-values'
import { ClubService } from '@src/service/club'

import './builder.sass'

@Component
export class Builder extends Vue {

  @Prop({ required: false })
  protected cssClass: string

  protected showConfirmPopup: boolean = false
  protected confirmMessage: any = ''
  protected notificationType: string = ''
  protected closeCallback: () => void

  created () {
    // load the default data to be used all over the platform child components
    return Promise.all([
      ClubService.loadClub(this.$store),
      DefaultValues.loadExerciseTags(this.$store),
      DefaultValues.loadActivities(this.$store)
    ])
  }

  /**
   * Sketch of the builder structure:
   *
   * ----------------------------------------------------------
   * | TopLeft        | TopMiddle       | TopRight   CloseBtn |
   * ---------------------------------------------------------
   * | Selector       | Builder         | Workout composition |
   * |                |                 |                     |
   * |                |                 |                     |
   * |                |                 |                     |
   * |                |                 |                     |
   * ----------------------------------------------------------
   *
   * Legend:
   * TopBarLeft & TopBarMiddle - zones at the top of the builder; they consist left side and the middle side
   * CloseBuilderBtn - icon displayed in the top right corner of the page;
   * Selector - contains available data to build a new item;
   * Builder - contains selected items;
   * If any zone does not appear, the other zones will be stretched to fit; e.g. if there is no button, the display will not be affected by this.
   *
   * @param {CreateElement} h
   * @returns {any}
   */

  render (h: CreateElement) {
    return <div class={'builder-wrapper ' + this.cssClass}>
      <div class='top-bar-wrapper row'>
        <div class='top-left'>{this.$slots.topLeft}</div>
        <div class='top-middle'>{this.$slots.topMiddle}</div>
        <div class='top-right'>{this.$slots.topRight}</div>
        <div class='close-btn'>{this.$slots.close}</div>
      </div>
      <div class='builder-wrapper-row row mobile-options'>
        {this.$slots.topMiddle}
      </div>
      <div class='mobile-unsupported-message'>
        <div>{this.$t('PAGE.CONTENT.BUILDER.UNSUPPORTED')}</div>
      </div>

      <div class='builder-wrapper-row row mobile-composition'>
        <div class='builder-column mobile-composition'>{this.$slots.composition}</div>
      </div>

      <div class='builder-wrapper-row row flex-grow-1'>
        {this.$slots.selector ? <div class='builder-column'>{this.$slots.selector}</div> : null}
        <div class='builder-column builder'>{this.$slots.builder}</div>
        <div class='builder-column composition'>{this.$slots.composition}</div>
      </div>

      {this.$slots.default}
    </div>
  }
}
